import React, { useState } from 'react';

import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsButton from '@cybs-ui/components/lib/button';
import { connect } from 'react-redux';
import Descriptions from './progressive-descriptions';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
import ParameterDescriptions from './parameter-description';
import {ResizableBox} from 'react-resizable';
import "react-resizable/css/styles.css";

class RequestFieldDescription extends React.Component {
  state = {
    heightDiv: 421,
  };

  handleKeyDown = (e) => {
    const { heightDiv: heightDiv } = this.state;
    switch(e.keyCode) {
      case 38: // up arrow
        this.setState({ heightDiv: heightDiv - 10 });
        break;
      case 40: // down arrow
        this.setState({ heightDiv: heightDiv + 10 });
        break;
      default:
        break;
    }
  }
  
  render() {

    if (!this.props.isRequestDescriptionExpanded) {
      return null; // Don't render anything
    }

    const { heightDiv } = this.state;
    const jsTree = this.props.jsTree || [];
    const hasQueryParams = this.props.hasQueryParams || false;
    const pathParams = this.props.pathParams || [];
    const hasBodyParams = this.props.hasBodyParams || false;
    const headerParams = this.props.headerParams || [];

    var expreq = document.querySelector("#expanded-request-field-descriptions .react-resizable");
    if(expreq && expreq.offsetHeight < 165){
      expreq.style.height = "421px";
    }
    var bodyHeight = (document.querySelector("#expanded-request-field-descriptions .requestexpanded-root"))?document.querySelector("#expanded-request-field-descriptions .requestexpanded-root").offsetHeight:0;
    var queryHeight = (document.querySelector("#expanded-request-field-descriptions .queryParametersDescription-requestexpanded"))?document.querySelector("#expanded-request-field-descriptions .queryParametersDescription-requestexpanded").offsetHeight:0;
    var pathHeight = (document.querySelector("#expanded-request-field-descriptions .pathParametersDescription-requestexpanded"))?document.querySelector("#expanded-request-field-descriptions .pathParametersDescription-requestexpanded").offsetHeight:0;
    var headerHeight = (document.querySelector("#expanded-request-field-descriptions .headerParametersDescription-requestexpanded"))?document.querySelector("#expanded-request-field-descriptions .headerParametersDescription-requestexpanded").offsetHeight:0;
    var totalHeight = bodyHeight + queryHeight + pathHeight + headerHeight;
    let maxHeight, minHeight;
    if (totalHeight > 3*421){
      maxHeight = 3*421;
      minHeight = 421;
    }
    else if(totalHeight > 421){
      maxHeight = totalHeight+100;
      minHeight = 421; 
    }
    else{
      maxHeight = totalHeight+100;
      minHeight = totalHeight+100;
    }
    
    return (
      
      <div id="expanded-request-field-descriptions" tabIndex="0" onKeyDown={this.handleKeyDown} style={{marginLeft: '20px', marginRight: '20px' }}>
        <ResizableBox width={1313} height={heightDiv} minConstraints={[1313,minHeight]} maxConstraints={[1313,maxHeight]} axis="y">
        <CybsCard
          header={
            <div>
              <div style={{ display: 'flex', height: '50px' }}>
              <CybsActionBar i18n={{ title: 'Request' }} dataTest="Request Field Description" />
                <div style={{ marginLeft: 'auto', marginRight: '5px', marginTop: '5px', marginBottom: '5px' }}>
                  <CybsButton
                    dataTest="secondaryButton"
                    i18n={{ label: 'Close' }}
                    onClick={() => {
                      putDataInDevCenterDataStore({ type: 'UPDATE_IS_REQUEST_DESCRIPTION_EXPANDED', isRequestDescriptionExpanded: false });
                    }
                    }
                    colorScheme="secondary"
                    id='request-descriptions-expanded-close'
                    className = "border_color_theme_primary"
                  />
                </div>
              </div>
              <hr style={{margin: '5px 0px 0px 0px'}} />
            </div>
          }
          dataTest="Request Field Description"
          style={{height: '100%'}}
        >
          <div style={{ height: '100%' }}>
              <div className="request-field-descriptions" style={{ height: '100%', overflowY: 'auto' }}>
                  {hasBodyParams &&<Descriptions
                    jsTree={jsTree}
                    display="block"
                    parent="root"
                    type="requestexpanded"
                  />}
                {hasQueryParams &&
                  <ParameterDescriptions type = "Query" src = "requestexpanded"/>  
                }
                {pathParams > 0 &&
                  <ParameterDescriptions type="Path" src="requestexpanded"/>  
                }
                {headerParams> 0 &&
                  <ParameterDescriptions type="Header" src="requestexpanded"/>  
                }
                </div>
              </div>
        </CybsCard>
        </ResizableBox>
      </div>
    )
  }
}



function mapStateToProps(state){
  return{
    jsTree: state.rhsReducer.jsTree,
    pathParams: state.rhsReducer.pathParameters,
    hasQueryParams: state.rhsReducer.hasQueryParams,
    hasBodyParams: state.lhsReducer.hasBodyParams,
    isRequestDescriptionExpanded: state.rhsReducer.isRequestDescriptionExpanded,
    headerParams : state.rhsReducer.headerParameters
  }
}

export default connect(mapStateToProps)(RequestFieldDescription);
